import { MapTo } from '@adobe/aem-react-editable-components';
import PhoneNumberAndIncome, { PhoneNumberAndIncomeEditConfig } from './PhoneNumberAndIncome';

export default MapTo('cob-corp-acquisition/components/creditonebank/phone-number-and-income')(PhoneNumberAndIncome, PhoneNumberAndIncomeEditConfig);